<template>
  <a-card class="auto-height">
    <h3 :style="{ marginBottom: '50px' }">第三方Launcher安装数量</h3>
    <a-spin :spinning="loading" class="antv-chart-mini">
      <div class="chart-wrapper">
        <v-chart :force-fit="true" :height="500" :data="records" :padding="padding">
          <v-tooltip />
          <v-axis />
          <v-bar position="name*value" :adjust="adjust" />
        </v-chart>
      </div>
    </a-spin>
  </a-card>
</template>

<script>
import { costTrend } from '@/api/vendor'

export default {
  data () {
    return {
      loading: false,
      records: [],
      padding: ['auto', 'auto', '40', '50'],
      // scale: [{
      //   dataKey: 'value',
      //   min: 0,
      //   max: 100
      // }],
      tooltip: ['name*value',
        (x, y) => ({
          name: x,
          value: y
        })
      ],
      adjust: [{
        type: 'dodge',
        marginRatio: 1 / 32
      }]
    }
  },
  mounted () {
    this.loadTrend()
  },
  methods: {
    loadTrend () {
      this.loading = true
      costTrend().then(response => {
        this.records = response.data
        // this.records.push({ name: '哈哈', value: 7 })
      }).catch(err => {
        console.log(err)
      }).finally(() => {
        this.loading = false
      })
    }
  }
}
</script>

<style lang="less" scoped>
  .antv-chart-mini {
    position: relative;
    width: 100%;
    height: 550px;

    .chart-wrapper {
      /*position: absolute;*/
      /*bottom: -28px;*/
      width: 100%;
    }
  }
</style>
